import { ActionTree } from 'vuex';
import { UserState } from '@/ui/store/types/user-module.types';
import { RootState } from '@/ui/store/types/root-module.types';
import { iUser } from '@/entities/user/user.types';
import { USER_MUTATIONS } from './mutations';

export const actions: ActionTree<UserState, RootState> = {
  mountUser({ commit }, user?: iUser) {
    commit(USER_MUTATIONS.SET_LOGGED_IN, !!user);

    if (user) {
      commit(USER_MUTATIONS.SET_USER, user);
      return;
    }

    commit(USER_MUTATIONS.SET_USER, undefined);
  },
};
